var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pt-7 pivot-table-container",attrs:{"flat":"","tile":""}},[_c('div',{ref:_vm.tabId,staticClass:"pivot-table",class:_vm.tabId})])}
var staticRenderFns = []

export { render, staticRenderFns }